import { translate as t } from "./locale";

export const PROJECT_LIMIT_MESSAGE =
    t("Magazyn projektów jest pełny. Usuń projekty, aby móc utworzyć nowy.");

export const isProjectLimitReached = async (response: Response): Promise<boolean> => {
    if (response.status !== 409) return false;
    try {
        const body = (await response.clone().json()) as {error?: string};
        return body.error === "PROJECT_LIMIT_REACHED";
    } catch {
        return false;
    }
};

interface DeletableProject {
    id: string;
    version: number;
}

interface DeleteSelectedProjectsOptions {
    csrfToken: string;
    fetchImpl?: typeof fetch;
    projects: DeletableProject[];
    onNetworkError?: (error: unknown) => void;
    selectedIds: Set<string>;
}

export const deleteSelectedProjects = async ({
    csrfToken,
    fetchImpl = fetch,
    onNetworkError,
    projects,
    selectedIds,
}: DeleteSelectedProjectsOptions): Promise<{deletedIds: string[]; failedIds: string[]}> => {
    const selectedProjects = projects.filter((project) => selectedIds.has(project.id));
    const results = await Promise.all(
        selectedProjects.map(async (project) => {
            try {
                const response = await fetchImpl(`/api/projects/${project.id}`, {
                    method: "DELETE",
                    headers: {
                        "If-Match": `"${project.version}"`,
                        "X-CSRF-Token": csrfToken,
                    },
                });
                return {id: project.id, deleted: response.ok};
            } catch (error) {
                onNetworkError?.(error);
                return {id: project.id, deleted: false};
            }
        }),
    );
    return {
        deletedIds: results.filter((result) => result.deleted).map((result) => result.id),
        failedIds: results.filter((result) => !result.deleted).map((result) => result.id),
    };
};
